import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pushing-pixels',
  templateUrl: './pushing-pixels.component.html',
  styleUrls: ['./pushing-pixels.component.scss'],
})
export class PushingPixelsComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
